import styled, { css } from 'styled-components';

export const CenterButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.spacing.km4};
    right: ${theme.spacing.km4};
    z-index: ${theme.zIndex.modal};
    height: ${theme.spacing.km8};
    width: ${theme.spacing.km8};
    background: ${theme.color.background.neutral.default};
    border-radius: 9px;
    border: ${theme.border.width.thinner} ${theme.border.style.solid} ${theme.color.border.neutral.strong};
    align-items: center;
    display: flex;
    justify-content: center;
    box-shadow: 0px 4px 4px -2px rgba(38, 47, 74, 0.08);
    box-shadow: 0px 2px 4px -2px rgba(38, 47, 74, 0.12);
    gap: 10px;
    padding: 7px;
  `}
`;
